export default __webpack_public_path__ + "static/media/featureDesktop.55f1c2fa.png";